export default __webpack_public_path__ + "static/Superstar-3632366e18395b9134dca2966a657dde.webp";